import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p393914732862435328',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
